import { useMutation, useQuery } from '@tanstack/react-query';
import { abortSync, forceProgramSync, forceSync, getCacheStatus } from './cacheApi';

export const createCacheHooks = ({ queryClient }) => {
    const useGetCacheStatus = () =>
        useQuery({
            queryKey: ['cacheStatus'],
            queryFn: getCacheStatus,
            refetchOnWindowFocus: false,
            retry: false,
        });

    const useForceSync = () =>
        useMutation({
            mutationFn: forceSync,
            onSuccess: (allPrograms) => {
                queryClient.invalidateQueries({ queryKey: ['cacheStatus'] });
                if (Array.isArray(allPrograms)) {
                    queryClient.setQueryData(['allEnrollmentData'], allPrograms);
                    allPrograms.forEach((programResult) => {
                        const queryKey = ['enrollmentData', { type: 'program', value: programResult.programName }];
                        queryClient.setQueryData(queryKey, programResult.data);
                    });
                }
            },
        });

    const useForceProgramSync = () =>
        useMutation({
            mutationFn: forceProgramSync,
            onSuccess: ({ programName, data }) => {
                queryClient.invalidateQueries({ queryKey: ['cacheStatus'] });
                if (programName && Array.isArray(data)) {
                    const programKey = ['enrollmentData', { type: 'program', value: programName }];
                    queryClient.setQueryData(programKey, data);
                    const allData = queryClient.getQueryData(['allEnrollmentData']);
                    if (Array.isArray(allData)) {
                        const updated = allData.map((entry) =>
                            entry.programName === programName ? { ...entry, data } : entry
                        );
                        queryClient.setQueryData(['allEnrollmentData'], updated);
                    }
                }
            },
        });

    const useAbortSync = () =>
        useMutation({
            mutationFn: abortSync,
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['cacheStatus'] });
            },
        });

    return {
        useGetCacheStatus,
        useForceSync,
        useForceProgramSync,
        useAbortSync,
    };
};
